import axios, {
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from 'axios';

// A client for calling Ecomm BFFs that includes the jwt token needed for authorization
const createClient = () =>
  axios.create({
    baseURL: 'https://api.example.com',
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const ecommClient = createClient();

ecommClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (typeof window !== 'undefined') {
    const token = window.sessionStorage.getItem('access_token') || '';
    if (config?.headers && token) config.headers.Authorization = token;
  }
  return config;
});

const axiosRequest = async <T>(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  // biome-ignore lint/suspicious/noExplicitAny: Generic api client so it can accept any body
  data?: any
): Promise<AxiosResponse<T>> => {
  const response: AxiosResponse<T> = await ecommClient({
    method,
    url,
    data,
  });

  return response;
};

export default axiosRequest;
